import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d52568f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center pb-4" }
const _hoisted_2 = { class: "w-5/6 md:w-full mx-auto" }
const _hoisted_3 = { class: "my-8 md:my-16" }
const _hoisted_4 = { class: "mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_salon_card = _resolveComponent("salon-card")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("Izbira prodajnega salona")), 1),
      _createVNode(_component_a_input, {
        style: {"max-width":"340px"},
        class: "mb-3 h-7",
        placeholder: _ctx.$t('Poštna številka ali kraj'),
        value: _ctx.searchValue,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event))
      }, null, 8, ["placeholder", "value"]),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("Dostava se obračuna naknadno glede na dogovor oz.želje stranke")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_dropdown, null, {
          overlay: _withCtx(() => [
            _createVNode(_component_a_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_menu_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.filterByPost && _ctx.filterByPost(...args)))
                    }, _toDisplayString(_ctx.$t("Po pošti")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterByCity && _ctx.filterByCity(...args)))
                    }, _toDisplayString(_ctx.$t("Po kraju")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, null, {
                  default: _withCtx(() => [
                    _createElementVNode("a", {
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.filterByTitle && _ctx.filterByTitle(...args)))
                    }, _toDisplayString(_ctx.$t("Po imenu")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("a", {
              class: "ant-dropdown-link",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
              style: {"font-size":"15px","color":"#0C5DA8"}
            }, _toDisplayString(_ctx.$t("Razvrsti")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSalons, (salon, index) => {
      return (_openBlock(), _createElementBlock("div", { key: salon }, [
        (index >= (_ctx.indexMax - _ctx.defaultPageSize) && index < _ctx.indexMax)
          ? (_openBlock(), _createBlock(_component_salon_card, {
              key: 0,
              salon: salon,
              salonSelected: _ctx.salonSelected
            }, null, 8, ["salon", "salonSelected"]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createVNode(_component_a_pagination, {
      current: _ctx.current,
      "onUpdate:current": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.current) = $event)),
      total: _ctx.filteredSalons?.length,
      defaultPageSize: _ctx.defaultPageSize,
      "show-less-items": ""
    }, null, 8, ["current", "total", "defaultPageSize"])
  ]))
}